import * as Sentry from '@sentry/react'

const env = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
}

export function initSentry() {
  if (env.ENVIRONMENT != 'development' && env.SENTRY_DSN) {
    Sentry.init({
      dsn: env.SENTRY_DSN,
      environment: env.ENVIRONMENT || 'development',
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
    })
  }
}
